const captcha = () => {
  return new Promise((resolve, reject) => {
    grecaptcha.enterprise.ready(async () => {
      let siteKey = process.env.VUE_APP_ONTICK_CAPTCHA_INVISIBLE_KEY;
      let action = "CHECKOUT";
      const token = await grecaptcha.enterprise.execute(siteKey, {
        action,
      });
      resolve(token);
    });
  });
};

export default captcha;
